import { render } from "./Generic.vue?vue&type=template&id=2988558e&lang=pug"
import script from "./Generic.vue?vue&type=script&lang=ts"
export * from "./Generic.vue?vue&type=script&lang=ts"
script.render = render

export default script